<template>

  <div class="summary">


      

 <section class="group" v-for="(group, index) in currentOrder" v-bind:key="group.guid">

    <b-table
        v-if="group.resolved_items"
        :data="group.resolved_items"
        :loading="false"
        icon-pack="fas"
       >

       <template slot-scope="props">

            <b-table-column field="sku" label="ID"  numeric>
                <span class="tag is-light">
                    {{ props.row.sku }}
                </span>
            </b-table-column>

            <b-table-column field="name" label="Product" >
                
                {{ props.row.name }}
                <ul>
                    <li v-for="addon in props.row.addons"><small><strong>+ </strong> <span class="tag is-dark">
                    {{ addon.sku }}
                </span> {{addon.name}} </small></li>
                </ul>
            </b-table-column>
            

        </template>

        <template slot="empty">No items</template>
        

    </b-table>

    

</section>

   
     <b-modal :active.sync="isSaveModalActive" has-modal-card>
       <component :is="modalType"></component>
    </b-modal>

  
  </div>

</template>

<script>
import { mapGetters, mapActions,mapMutations } from 'vuex'
import { utils } from '@/mixins/utils.js'


export default {

  name: 'Summary',

  mixins:[utils],


  data:function(){
      
      return{

          order:[],

            isSaveModalActive: false,
          
          columns: [
            {
                field: 'name',
                label: 'Modules'
            },
            {
                field: 'sku',
                label: 'SKU',
                numeric: true
            }
          ]
          
      }

  },




  computed:{

      ...mapGetters(['all_attributes', 'all_addons', 'all_sections', 'currentUser', 'currentOrder']),

      config: {

        get() {
            return this.$store.state.config
        }
      },

      modalType(){
        return (this.currentUser)? 'RequestForm' : 'Login';
    },

    
      hasItems(){
          return this.config.length>0;
      }

  },

  created(){
     this.buildOrder(this.$store.state.config);
  },

  methods:{


    ...mapMutations(['SET_ORDER']),

    frameDetails(frame){
        return this.all_sections[frame.id].name;
    },

    buildOrder(config){

       
        var order = [];

        config.forEach(group=> {
            
            var orderGroup = {
                resolved_items:[]
            };

            var frameObj = this.all_sections[group.frame.id];
            
            var resolvedFrame = this.resolveVariantModels({ variants : frameObj.variants, settings: group.settings, includeModels : false, localScope:true})

            orderGroup.resolved_items.push(resolvedFrame);

            if(group.items){

                group.items.forEach(item=>{
                
                    var itemObj = this.all_sections[item.id];
        
                    var resolvedItem = this.resolveVariantModels({ variants : itemObj.variants, settings: item.settings, includeModels : false, localScope:true})

                    orderGroup.resolved_items.push(resolvedItem);

                });
            }

            order.push(orderGroup);
        });

        this.SET_ORDER(order);
    },

    itemsWithAddons(group){

        var ids = [], addons;
        
        if(group.hasOwnProperty('items') && group.items.length > 0){
            ids = group.items.map(({ settings }) => settings.addons)
        }

        return ids;
    },

      addonDetails(addon){

        return this.all_addons[addon];
    
      }

      
  }
}
</script>


<style>
.b-table .table tr.detail, .b-table .table tr.detail .detail-container {
    box-shadow: none;
    background: none;
    padding:10px;
}
.b-table .table tr.detail td{
    padding:0;
}
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.summary{
 
 padding:1em;

}

.group{
    margin-bottom:1em;
}

.request-btn{
    width:100%;

}


</style>